import { render, staticRenderFns } from "./View13.vue?vue&type=template&id=20cf17dc"
import script from "./View13.vue?vue&type=script&lang=js"
export * from "./View13.vue?vue&type=script&lang=js"
import style0 from "./View13.vue?vue&type=style&index=0&id=20cf17dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports